<template>
    <div class="d-flex align-center justify-end">
      <v-chip 
        v-for="tag in appointment.tags"
        :key="tag.id"
        class="mx-2 yellow lighten-3" 
        small
      >
        <span>{{ tag.name }}</span>
        <v-btn
          @click="removeTag(tag.id)"
          class="ml-1" 
          :disabled="isLoading"
          x-small 
          icon
        >
          <v-icon x-small>mdi-close-thick</v-icon>
        </v-btn>
      </v-chip>
    
      <QaAppointmentTagsMenu />
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import QaAppointmentTagsMenu from './QaAppointmentTagsMenu'
  
  export default {
    name: 'QaAppointmentTags',
  
    components: {
        QaAppointmentTagsMenu,
    },
  
    props: {
      appointment: {
        type: Object,
        required: true,
        default: {}
      }
    },
  
    data: () => {
      return {
  
      }
    },
  
    computed: {
      ...mapGetters(['isLoading'])
    },
  
    methods: {
      ...mapActions(['removeTagsFromAppointment']),
  
      removeTag(tagId) {
        const body = {
          appointment_id: this.appointment.id,
          tags_ids: [tagId]
        }
  
        this.removeTagsFromAppointment(body)
      },
    }
  }
  </script>
  
  <style>
    .v-chip span {
      max-width: none !important;
    }
  </style>